module.exports = __webpack_public_path__ + "img/全蝎.e0d547f6.jpg";